import { render, staticRenderFns } from "./SidebarV2Collapse.vue?vue&type=template&id=c264f714&scoped=true"
import script from "./SidebarV2Collapse.vue?vue&type=script&lang=js"
export * from "./SidebarV2Collapse.vue?vue&type=script&lang=js"
import style0 from "./SidebarV2Collapse.vue?vue&type=style&index=0&id=c264f714&prod&lang=scss&scoped=true"
import style1 from "./SidebarV2Collapse.vue?vue&type=style&index=1&id=c264f714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c264f714",
  null
  
)

export default component.exports